import { Toaster as Sonner, toast } from "sonner";

/**
 * EQUIA-themed Sonner Toaster.
 * Dark panel, hairline border, gold/red accents — matches the "quiet luxury" aesthetic.
 */
const Toaster = ({ ...props }) => {
  return (
    <Sonner
      theme="dark"
      className="toaster group"
      position="top-right"
      richColors={false}
      toastOptions={{
        unstyled: false,
        classNames: {
          toast:
            "group toast !bg-[#0A0A0A] !text-white !border !border-white/[0.12] !shadow-2xl !rounded-none !font-sans",
          title: "!text-white !text-sm !font-medium !tracking-tight",
          description: "!text-white/55 !text-xs !mt-0.5",
          actionButton:
            "!bg-[#D4AF37] !text-black !rounded-none !text-[11px] !uppercase !tracking-[0.1em] hover:!bg-[#B5952F]",
          cancelButton:
            "!bg-transparent !border !border-white/10 !text-white/60 !rounded-none !text-[11px] !uppercase !tracking-[0.1em]",
          success: "!border-l-2 !border-l-[#D4AF37]",
          error: "!border-l-2 !border-l-red-500/70",
          info: "!border-l-2 !border-l-white/30",
          warning: "!border-l-2 !border-l-amber-400/70",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
